<template>
  <div class="stars">
    <div class="star" v-for="(redStar, index) in redCount" v-bind:key="index">
      <img src="../../static/img/star_red@2x.png" alt="red-star" />
    </div>
    <div class="star" v-if="dotCount">
      <img src="../../static/img/star_grey@2x.png" alt="gary-star" />
      <div class="cover-red-star" :style="{ width: coverWidth }"></div>
    </div>
    <div class="star" v-for="(grayStar, index) in grayCount" :key="index">
      <img src="../../static/img/star_grey@2x.png" alt="gary-star" />
    </div>
  </div>
</template>

<script>
import utils from '../services/tools';

export default {
  name: 'stars',
  props: {
    score: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      redCount: Math.floor(this.score),
      dotCount: this.score - Math.floor(this.score),
      grayCount: 5 - Math.ceil(this.score),
    };
  },
  computed: {
    coverWidth() {
      return `${this.dotCount * utils.rem2px(0.12)}px`;
    },
  },
};
</script>

<style scoped lang="less">
.stars {
  display: flex;
  justify-content: space-between;
  width: 0.68rem;
  .star {
    position: relative;
    img {
      width: 0.12rem;
      height: 0.12rem;
    }
    .cover-red-star {
      position: absolute;
      left: 0;
      top: 0;
      width: 0.12rem;
      height: 0.12rem;
      background-image: url(../../static/img/star_red@2x.png);
      background-repeat: no-repeat;
      background-position: left top;
      background-size: 0.12rem 0.12rem;
    }
  }
}
</style>
